const list = "Nav-module_list_bCnfFR-g";
const styles = {
  list
};
export {
  styles as default,
  list
};
